module.exports = __webpack_public_path__ + "media/img/trainings/trainings-banner-icon-9b17eea769c25d9b70d0d6e446cc885c.svg";